import Objects from "../objects/Objects.js";
class UI {
	
	constructor() {
		this.jqObj = null;
	}
	
	setBaseJQueryObject(jqObj) {
		if (jqObj instanceof UI) {
			this.jqObj = jqObj.getJQueryRepresentation();
		} else {
			this.jqObj = jqObj;
		}
	}
	
	getJQueryRepresentation() {
		return this.jqObj;
	}
	
	remove() {
		this.getJQueryRepresentation().remove();
		this.setBaseJQueryObject(null);
	}
	
	hide() {
		this.jqObj.hide();
	}
	
	show() {
		this.jqObj.show();
	}
	
	static append(toAppend) {
		let mainContent = UI.getMainContent();
		if (mainContent == null) {
			return;
		}
		if (toAppend instanceof UI) {
			mainContent.append(toAppend.getJQueryRepresentation());
		} else {
			mainContent.append(toAppend);
		}
	}

	static getMainContent() {
		let mainContent = $('.main_content');
		if(!mainContent.length){
			console.log('main_contet not found');
			return null;
		}
		return mainContent
	}
	
	static htmlDecode(value){
		return $('<div/>').html(value).text();
	}

	static addToInfo(){
		var infoDiv = $('#info_div');
		if(! infoDiv.length){
			var mainContent = $('.main_content');
			if(mainContent.length){
				mainContent.prepend('<div id="info_div" class="info_box"></div>');
				infoDiv = $('#info_div');
			}else{
				console.log('main_contet not found');
				return;
			}
		}
		var infoTable = infoDiv.children('table');
		if(! infoTable.length){
			infoDiv.append('<table class="noborder"></table>');
			infoTable = infoDiv.children('table');
		}
		
		var infoTableBody = infoTable.children('tbody');
		if(! infoTableBody.length){
			infoTable.append('<tbody></tbody>');
			infoTableBody = infoTable.children('tbody');
		}
		var i;
		for (i = 0; i < arguments.length; i++) {
			infoTableBody.append('<tr><td>' + arguments[i] + '</tr></td>');
		}
	}

	static addToError(){
		var errorDiv = $('#error_div');
		if(! errorDiv.length){
			var mainContent = $('.main_content');
			if(mainContent.length){
				mainContent.prepend('<div id="error_div" class="error_box"></div>');
				errorDiv = $('#error_div');
			}else{
				console.log('main_contet not found');
				return;
			}
		}
		var errorTable = errorDiv.children('table');
		if(! errorTable.length){
			errorDiv.append('<table class="noborder"></table>');
			errorTable = errorDiv.children('table');
		}
		
		var errorTableBody = errorTable.children('tbody');
		if(! errorTableBody.length){
			errorTable.append('<tbody></tbody>');
			errorTableBody = errorTable.children('tbody');
		}
		var i;
		for (i = 0; i < arguments.length; i++) {
			errorTableBody.append('<tr><td>' + arguments[i] + '</tr></td>');
		}
	}

	static cleanError(){
		var errorDiv = $('#error_div');
		if(errorDiv){
			errorDiv.html('');
		}
	}

	static removeHelpOverley(){
		var helpBoxDiv = $('#helpBox');
		if(helpBoxDiv){
			helpBoxDiv.remove();
		}
	}
}
export default UI;